import * as React from 'react'
import { observer } from 'mobx-react'
import RemoveCouponAsAdminViewModel from './RemoveCouponAsAdminViewModel'
import {
  ModalSheet,
  ModalSheetHeader,
  ModalSheetContentTitle,
  ModalSheetFooterButtonGroup,
  ModalSheetContent,
  ModalSheetFooter,
  ModalSheetFooterSpacer,
  ModalSheetContentDescription,
  ModalSheetContentIllustration,
  ModalSheetContentBlock,
} from 'components/ModalSheet'
import Button from 'components/Button'
import styles from './RemoveCouponAdAdminDialog.sass'

interface RemoveCouponAsAdminDialogProps {
  vm: RemoveCouponAsAdminViewModel
}

export default observer(function RemoveCouponAsAdminDialog({
  vm,
}: RemoveCouponAsAdminDialogProps) {
  return (
    <ModalSheet
      showing={vm.showing}
      onRequestClose={vm.removeCouponAsAdmin.pending ? undefined : vm.close}
      disableCloseOnEsc
    >
      <>
        <ModalSheetHeader withCloseButton />
        <ModalSheetContent>
          <ModalSheetContentBlock>
            <ModalSheetContentTitle>
              <ModalSheetContentIllustration
                src={require('assets/images/img_confirm-action.svg')}
                alt="Illustration of a girl with her laptop and a plus symbol"
              />
              You are about to remove a coupon
            </ModalSheetContentTitle>
            <ModalSheetContentDescription>
              Are you sure you want to remove coupon code &nbsp;
              <span className={styles.emphasize}>{vm.couponDisplay}</span>
              &nbsp; from the job? Discount will no longer be applied.
            </ModalSheetContentDescription>
          </ModalSheetContentBlock>
        </ModalSheetContent>

        <ModalSheetFooter>
          <ModalSheetFooterSpacer />
          <ModalSheetFooterButtonGroup>
            <Button type="default" onClick={vm.close}>
              Close
            </Button>
            <Button
              type="danger"
              loading={vm.removeCouponAsAdmin.pending}
              data-test="remove-coupon-as-admin-submit-button"
              onClick={vm.removeCouponAsAdmin}
            >
              Remove Coupon
            </Button>
          </ModalSheetFooterButtonGroup>
        </ModalSheetFooter>
      </>
    </ModalSheet>
  )
})
